var map = {
	"./asset-hyperlink.json": 1539,
	"./blockquote.json": 1540,
	"./document.json": 1541,
	"./embedded-asset-block.json": 1542,
	"./embedded-entry-block.json": 1543,
	"./embedded-entry-inline.json": 1544,
	"./embedded-resource-block.json": 1545,
	"./embedded-resource-inline.json": 1546,
	"./entry-hyperlink.json": 1547,
	"./heading-1.json": 1548,
	"./heading-2.json": 1549,
	"./heading-3.json": 1550,
	"./heading-4.json": 1551,
	"./heading-5.json": 1552,
	"./heading-6.json": 1553,
	"./hr.json": 1554,
	"./hyperlink.json": 1555,
	"./list-item.json": 1556,
	"./ordered-list.json": 1557,
	"./paragraph.json": 1558,
	"./resource-hyperlink.json": 1559,
	"./table-cell.json": 1560,
	"./table-header-cell.json": 1561,
	"./table-row.json": 1562,
	"./table.json": 1563,
	"./text.json": 1564,
	"./unordered-list.json": 1565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1538;